var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content main-crm-content" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "container new-list" },
      _vm._l(_vm.newList, function(item, key) {
        return _c("div", { key: key, staticClass: "item" }, [
          _c("p", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
          _c("img", { attrs: { src: item.icon, alt: "" } }),
          _c("p", { staticClass: "con" }, [_vm._v(_vm._s(item.value))])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container content-title" }, [
      _c("img", {
        staticClass: "img-box",
        attrs: { src: require("static/images/trait/shop.png"), alt: "oa" }
      }),
      _c("h3", { staticClass: "services-title1" }, [_vm._v("商城管理系统")]),
      _c("p", { staticClass: "container-sub-title sub-title" }, [
        _vm._v(
          "易安捷始终坚持电商软件的研发及服务，紧跟电商发展趋势，不断追求完美和极致，致力于为企业打造拥有核心竞争力的电商生态系统。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1680ccb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1680ccb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/shop/Content.vue
// module id = enzR
// module chunks = 14